import { createContext, useContext, useState, useEffect } from 'react';

export const THEMES = [
  {
    id: 'magical',
    name: '',
    emoji: '✨',
    desc: '',
    swatches: ['#818CF8', '#C084FC', '#FCA5A5'],
    type: 'light',
  },
  {
    id: 'bedtime',
    name: '',
    emoji: '🌙',
    desc: '',
    swatches: ['#1E3A5F', '#1E293B', '#F59E0B'],
    type: 'dark',
  },
];

const VALID_THEME_IDS = new Set(THEMES.map((t) => t.id));
const DEFAULT_THEME = 'magical';

function normalizeThemeId(id) {
  return VALID_THEME_IDS.has(id) ? id : DEFAULT_THEME;
}

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() =>
    normalizeThemeId(localStorage.getItem('storycraft_theme') || DEFAULT_THEME),
  );

  const setTheme = (id) => {
    setThemeState(normalizeThemeId(id));
  };

  useEffect(() => {
    const isLanding = window.location.pathname === '/' || window.location.hash === '#/';
    if (isLanding) return;

    const resolved = normalizeThemeId(theme);
    document.documentElement.setAttribute('data-theme', resolved);
    const selectedTheme = THEMES.find((t) => t.id === resolved);
    if (selectedTheme?.type === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('storycraft_theme', resolved);
    if (resolved !== theme) {
      setThemeState(resolved);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme: normalizeThemeId(theme), setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
};
